import { Component, ElementRef, EventEmitter, NgZone, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { WizardNavigationComponent } from '../../../../shared/components/wizard-navigation/wizard-navigation.component';
import { SelectInputComponent, TextInputComponent, DateInputComponent, SelectOption } from 'ddmo-storybook-lib';
import { DemographicService } from '../../services/demographics.service';
import { catchError, forkJoin, of, tap } from 'rxjs';
import { LABELS } from '../../../../shared/constants/lables.constants';
import { SharedService } from '../../../../shared/services/shared.service';
import { LoaderService } from '../../../../shared/services/loader.service';
import $ from 'jquery';
export function minAgeValidator(minAge: number) {
  return (control: AbstractControl) => {
    if (!control.value) return null;
    const today = new Date();
    const dob = new Date(control.value);
    if (isNaN(dob.getTime())) return null;
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age < minAge ? { minAge: true } : null;
  };
}
export function pastDateValidator() {
  return (control: AbstractControl) => {
    if (!control.value) return null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const inputDate = new Date(control.value);
    if (isNaN(inputDate.getTime())) return null;
    return inputDate > today ? { futureDate: true } : null;
  };
}
@Component({
  selector: 'app-dentist-demographics',
  imports: [CommonModule, ReactiveFormsModule, WizardNavigationComponent, SelectInputComponent, TextInputComponent, DateInputComponent],
  templateUrl: './dentist-demographics.component.html',
  styleUrl: './dentist-demographics.component.scss'
})
export class DentistDemographicsComponent implements OnInit {
  years: number[] = [];
  schoolsList: any = [];
  specialityList: any = [];
  stateOptions: SelectOption[] = LABELS.STATE_CODES_LIST;
  showError: boolean = false;
  customErrorMessagesSsn = { minlength: LABELS.ERROR_MESSAGES.minimumNineCharecter, required: 'Required' };
  customErrorMessagesZip = { minlength: LABELS.ERROR_MESSAGES.minimumFiveCharecter, required: 'Required' };
  suggestionCount: any = 0;
  private scrollHandler = this.onScroll.bind(this);
  selectedAddress: any = '';
  showFulladdressError = false
  isPlaceSelected: boolean = false;
  @ViewChildren('locationInput') locationInputs!: QueryList<ElementRef>;

  constructor(private fb: FormBuilder, private router: Router, private service: DemographicService,
    private sharedService: SharedService, private datePipe: DatePipe, private loader: LoaderService, private ngZone: NgZone,
  ) {

    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= 1950; i--) {
      this.years.push(i);
    }
  }
  EMAIL_PATTERN = LABELS.EMAIL_PTTERN;
  SPECIAL_CHARECTER = LABELS.SPECIAL_CHARECTER;
  public demographicFormGroup = new FormGroup({
    dob: new FormControl<Date | string>('', [Validators.required, minAgeValidator(18)]),
    gender: new FormControl('', [Validators.required]),
    ethnicity: new FormControl('', [Validators.required]),
    location: new FormControl(''),
    city: new FormControl(''),
    state: new FormControl('', [Validators.minLength(2), Validators.maxLength(2)]),
    zip: new FormControl('', [Validators.minLength(5), Validators.maxLength(5)]),
    email: new FormControl('', [Validators.required, Validators.pattern(this.EMAIL_PATTERN)]),
    dentalSchool: new FormControl('', [Validators.required]),
    otherSchool: new FormControl(''),
    yearGraduated: new FormControl<Date | string>('', [Validators.required, pastDateValidator()]),
    specialty: new FormControl('', [Validators.required]),
    degree: new FormControl('', [Validators.required]),
    educationType: new FormControl('DENTAL_SCHOOL')
  });

  FIELD_LIMITS = {
    address: { type: 'string', maxLength: 200 },
    city: { type: 'string', maxLength: 100 },
    zip: { type: 'string', maxLength: 5 },
    email: { type: 'string', maxLength: 90 },
    otherSchool: { type: 'string', maxLength: 200 }
  }

  genderOptions: SelectOption[] = [
    { value: "unknown", viewValue: "Unknown" },
    { value: "nonbinary", viewValue: "Nonbinary" },
    { value: "male", viewValue: "Male" },
    { value: "female", viewValue: "Female" },]
  degreeOptions: SelectOption[] = [
    { value: "DDS", viewValue: "DDS" },
    { value: "MD", viewValue: "MD" },
    { value: "DMD", viewValue: "DMD" },]

  educationTypeOptions: SelectOption[] = [
    { value: "DENTAL_SCHOOL", viewValue: "Dental school" },
    { value: "OTHER", viewValue: "Other" },
    { value: "SPECIALITY_TRAINING", viewValue: "Speciality training" },
    { value: "UNDERGRADUATE", viewValue: "Undergraduate" },
  ]

  ethinicityOptions: SelectOption[] = [
    { value: "Unknown", viewValue: "Unknown" },
    { value: "Not Provided", viewValue: "Not provided" },
    { value: "Not Applicable", viewValue: "Not Applicable" },
    { value: "Asian or Pacific Islander", viewValue: "Asian or Pacific Islander" },
    { value: "Black", viewValue: "Black" },
    { value: "Caucasian", viewValue: "Caucasian" },
    { value: "Subcontinent Asian American", viewValue: "Subcontinent Asian American" },
    { value: "Asian Pacific American", viewValue: "Asian Pacific American" },
    { value: "Native American", viewValue: "Native American" },
    { value: "Hispanic", viewValue: "Hispanic" },
    { value: "American Indian or Alaskan Native", viewValue: "American Indian or Alaskan Native" },
    { value: "Black (Non-Hispanic)", viewValue: "Black (Non-Hispanic)" },
    { value: "White (Non-Hispanic)", viewValue: "White (Non-Hispanic)" }];

  demographicData: any
  isRecred: boolean = false;
  action: any
  dentistInfo: any
  today: any = new Date();
  minDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth(),
    new Date().getDate()
  );
  impersonatedUser: any = localStorage.getItem("impersonatedUser") ?? ""

  ngOnInit() {
    $('.pac-container').remove();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.action = localStorage.getItem('Action')
    this.isRecred = this.action == 'Recred' ? true : false;
    this.loader.show();
    forkJoin({
      schools: this.getSchool(),
      specialities: this.getSpeciality()
    }).subscribe({
      next: () => {
        this.loader.hide();
        let demographicObj = localStorage.getItem('demographics')
        this.demographicData = demographicObj ? JSON.parse(demographicObj) : null;
        if (this.demographicData) {
          this.bindForm();
        }
      },
      error: () => {
        this.loader.hide();
      }
    });
    const isRecred = this.getAction();
    this.demographicFormGroup.get('otherSchool')?.disable(); 
    this.onSchoolChange();
    if (this.impersonatedUser) {
      this.demographicFormGroup.disable();
    }
  }
  bindForm() {
    let schoolobj = this.schoolsList.find((school: any) => school.viewValue?.toUpperCase() == this.demographicData.dentalSchool?.toUpperCase());
    const userDetails: any = JSON.parse(localStorage.getItem('loggedUserDetails')!);
    const loggedUserEmail = userDetails?.emailAddress || userDetails?.email || '';
    this.demographicFormGroup.patchValue({
      dob: this.demographicData?.DOB ? new Date(this.sharedService.formatDate(this.demographicData.DOB)) : "",
      gender: this.demographicData.gender?.toLowerCase(),
      ethnicity: this.demographicData.ethnicity,
      location: this.demographicData.address1,
      city: this.demographicData.city,
      state: this.demographicData.state,
      zip: this.demographicData.zip,
      email: this.demographicData.email || loggedUserEmail,
      dentalSchool: schoolobj?.value,
      otherSchool: this.demographicData.otherSchool,
      yearGraduated: this.demographicData?.yearGraduated ? new Date(this.sharedService.formatDate(this.demographicData.yearGraduated)) : "",
      specialty: this.demographicData.specialtyId ? this.demographicData.specialtyId : this.demographicData.specialty,
      degree: this.demographicData.degree,
      educationType: this.demographicData.educationType || 'DENTAL_SCHOOL'
    })
    if(!this.demographicData.email){
      const demographics = JSON.parse(localStorage.getItem('demographics') || '{}');
      demographics.email = loggedUserEmail;
      localStorage.setItem('demographics', JSON.stringify(demographics));
    }
  }
  getSchool() {
    let schools = localStorage.getItem('schools');
    let schoolList = schools ? JSON.parse(schools) : [];
    if (schoolList.length > 0) {
      this.schoolsList = schoolList;
      return of(this.schoolsList);
    } else {
      return this.service.getSchoolList().pipe(
        tap((response: any) => {
          this.schoolsList = this.formatDropDown(response);
          localStorage.setItem('schools', JSON.stringify(this.schoolsList));
          localStorage.setItem('schoolswithAddresses', JSON.stringify(response));
        }),
        catchError((error: any) => {
          this.sharedService.logError("APIFailed", "FileDentist-DemographicsComponent - getSchoolList, Method:getSchool", this.router.url.split('?')[0], error).subscribe();
          return of(this.schoolsList);
        })
      );
    }
  }
  getSpeciality() {
    let speciality = localStorage.getItem('speciality');
    let specialityList = speciality ? JSON.parse(speciality) : [];
    if (specialityList.length > 0) {
      this.specialityList = specialityList;
      return of(this.specialityList);
    } else {
      return this.service.getSpecialityList().pipe(
        tap((response: any) => {
          this.specialityList = this.formatDropDown(response);;
          localStorage.setItem('speciality', JSON.stringify(this.specialityList));
        }),
        catchError((error: any) => {
          this.sharedService.logError("APIFailed", "FileDentist-DemographicsComponent - getSpecialityList, Method:getSpeciality", this.router.url.split('?')[0], error).subscribe();
          return of(this.specialityList);
        })
      );
    }

  }
  formatDropDown(arr: any) {
    return arr.map((item: any) => ({
      value: item.Id,
      viewValue: item.Name
    }));
  }
  onBack() {
    this.onNext(true);
  }
  onCancel() {
    this.router.navigate(['/landing']);
  }

  onNext(isBackButton: any) {
    let formData: any = this.demographicFormGroup.getRawValue();
    let eventId = localStorage.getItem('credentialingEventId')
    const loginUserId = localStorage.getItem("loggedUserId");
    const loggedUserDetails: any = JSON.parse(localStorage.getItem('loggedUserDetails') || '{}');
    const resolvedEmail = (formData.email || this.demographicData?.email || loggedUserDetails?.emailAddress || loggedUserDetails?.email || '').toString().trim();
    let schoolobj = this.schoolsList.find((school: any) => school.value == formData.dentalSchool);
    if (!this.sharedService.validateFormLimits(this.demographicFormGroup, this.FIELD_LIMITS)) return;
    this.loader.show();
    let request = {
      ...(this.demographicData?.demoGraphicId && { demographicId: this.demographicData?.demoGraphicId }),
      credentialEventId: this.demographicData?.credentialingEventId ? this.demographicData.credentialingEventId : eventId,
      dateOfBirth: formData.dob ? this.formatDate(formData.dob) : "",
      gender: formData.gender,
      ethnicity: formData.ethnicity,
      address1: formData.location,
      city: formData.city,
      state: formData.state,
      zip: formData.zip,
      email: resolvedEmail,
      dentalSchool: schoolobj?.viewValue,
      otherDentalSchool: formData.otherSchool,
      yearGraduated: formData.yearGraduated ? this.formatDate(formData.yearGraduated) : "",
      specialtyId: formData.specialty ? formData.specialty : null,
      degree: formData.degree,
      createdUserId: loginUserId ? Number(loginUserId) : 0,
      activeFlg: 1,
      firstName: this.demographicData.firstName ? this.demographicData.firstName : null,
      lastName: this.demographicData.lastName ? this.demographicData.lastName : null,
      middleName: this.demographicData.middleName ? this.demographicData.middleName : null,
      educationType: formData.educationType ? formData.educationType : null,
    }

    this.service.saveDemographics(request).subscribe({
      next: (response: any) => {
        this.loader.hide();
        this.setDemographicData(request, response);
        if (isBackButton) {
          this.router.navigate(['/landing']);
        } else {
          this.router.navigate(['/credentialing/credentials']);
        }

      }, error: (err: any) => {
        this.loader.hide();
        this.sharedService.logError("APIFailed", "FileDentist-DemographicsComponent - saveDemographics, Method:onNext", this.router.url.split('?')[0], err).subscribe();
      }
    })

  }

  formatDate(date: any) {
    return this.datePipe.transform(date, 'yyyy-MM-dd');
  }

  restrictNonNumeric(event: KeyboardEvent): void {
    this.sharedService.preventNonNumeric(event);
  }

  onSchoolChange() {
    const selectedSchoolValue = this.demographicFormGroup.get('dentalSchool')?.value;
    const otherSchoolCtrl = this.demographicFormGroup.get('otherSchool');

    const selectedSchool = this.schoolsList.find(
      (school: { value: any; }) => school.value === String(selectedSchoolValue)
    );

    const isOtherSchool =
      selectedSchool?.viewValue?.toLowerCase() === 'my school is not listed' ||
      selectedSchool?.viewValue?.toLowerCase() === 'other';

    if (isOtherSchool) {
      otherSchoolCtrl?.enable();
      otherSchoolCtrl?.setValidators([Validators.required]);
    } else {
      otherSchoolCtrl?.reset()
      otherSchoolCtrl?.clearValidators();
      otherSchoolCtrl?.disable();
    }

    otherSchoolCtrl?.updateValueAndValidity();
  }

  setDemographicData(request: any, response: any) {
    let demographicData = {
      "demoGraphicId": response.demographicId,
      "DOB": request.dateOfBirth,
      "gender": request.gender,
      "ethnicity": request.ethnicity,
      "address1": request.address1,
      "address2": null,
      "city": request.city,
      "state": request.state,
      "zip": request.zip,
      "email": request.email,
      "dentalSchool": request.dentalSchool,
      "otherSchool": request.otherDentalSchool,
      "yearGraduated": request.yearGraduated,
      "specialty": request.specialtyId,
      "degree": request.degree,
      "firstName": request.firstName,
      "lastName": request.lastName,
      "middleName": request.middleName,
      "educationType": request.educationType

    }
    localStorage.setItem('demographics', JSON.stringify(demographicData));
  }
  get checkFormIsvalid() {
    return this.demographicFormGroup.valid;
  }
  onLocationChange(val: any) {
    $('.pac-container').addClass('hide');
    if (val && val?.length > 0) { this.showError = false }
  }
  async onFocus() {
    $('.pac-container').addClass('hide');
    await this.repositionDropdown();
  }
  async repositionDropdown() {

    const input = this.locationInputs.get(0)?.nativeElement;
    const pacContainer = document.querySelector('.pac-container') as HTMLElement;

    if (pacContainer && input) {
      // Style positioning

      pacContainer.style.position = 'absolute';
      const rect = this.locationInputs.get(0)?.nativeElement.getBoundingClientRect();
      pacContainer.style.top = `${rect.bottom + window.scrollY}px`;
      pacContainer.style.left = `${rect.left}px`;
      pacContainer.style.width = `${rect.width}px`;
    }

  }

  async onScroll() {
    $('.pac-container').addClass('hide');
  }
  async ngAfterViewInit() {
    if ((window as any).google) {
      await this.initializeAutoComplete();
    }
    else {
      const interval = setInterval(async () => {
        if ((window as any).google) {
          clearInterval(interval);
          await this.initializeAutoComplete();
        }
      }, 300)
    }
    //
    this.locationInputs.changes.subscribe(async () => {
      $('.pac-container').addClass('hide');
      await this.initializeAutoComplete();
    })
  }
  async initializeAutoComplete() {
    const visibleInputs = this.locationInputs.filter(
      (inputRef: ElementRef) =>
        !!inputRef.nativeElement.offsetParent
    )
    visibleInputs.forEach((inputRef) => {
      const autoComplete = new (window as any).google.maps.places.Autocomplete(
        inputRef.nativeElement, {
        types: ['address'],
        componentRestrictions: { country: 'us' }
      }
      );

      const autoCompleteService = new google.maps.places.AutocompleteService()

      autoComplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          const place = autoComplete.getPlace();
          if (place && place.formatted_address) {
            this.showError = false;
            this.selectedAddress = place.formatted_address || '';
            this.isPlaceSelected = true;
            let homeAddress = '';
            let city = '';
            let state = '';
            let zip = '';
            let streetNumber = '';
            let route = '';
            place.address_components?.forEach((component: any) => {

              // Street Number
              if (component.types.includes('street_number')) {
                streetNumber = component.long_name;
              }

              // Street Name
              if (component.types.includes('route')) {
                route = component.long_name;
              }
              // City
              if (!city && component.types.includes('locality')) {
                city = component.long_name;
              }
              else if (!city && component.types.includes('postal_town')) {
                city = component.long_name;
              }
              else if (!city && component.types.includes('sublocality')) {
                city = component.long_name;
              }
              else if (!city && component.types.includes('administrative_area_level_2')) {
                city = component.long_name;
              }
              // State
              if (component.types.includes('administrative_area_level_1')) {
                state = component.short_name;
              }

              // ZIP
              if (component.types.includes('postal_code')) {
                zip = component.long_name;
              }
            });

            // Build address line
            homeAddress = `${streetNumber} ${route}`.trim();
            this.demographicFormGroup.patchValue(({
              "location": homeAddress
            }))
            this.demographicFormGroup.patchValue(({
              "city": city
            }))
            this.demographicFormGroup.patchValue(({
              "state": state
            }))
            this.demographicFormGroup.patchValue(({
              "zip": zip
            }))
            if (!zip) {
              this.showFulladdressError = true
            } else {
              this.showFulladdressError = false
            }
            this.validateLocation(this.selectedAddress);
          }
        })
      })

      inputRef.nativeElement.addEventListener('input', (e: any) => {
        this.isPlaceSelected = false;
        const value = e.target.value;

        if (!value) {
          this.suggestionCount = 0;
          return;
        }
        autoCompleteService.getPlacePredictions(
          {
            input: value, types: ['address'],
            componentRestrictions: { country: 'us' }
          },
          (predictions, status) => {
            this.ngZone.run(async () => {
              if (status === google.maps.places.PlacesServiceStatus.OK && predictions) {
                await this.repositionDropdown();
                $('.pac-container').removeClass('hide');
                this.suggestionCount = predictions.length;
              }
              else {
                this.suggestionCount = 0;
              }
            })
          }
        )
      })
      const input = inputRef.nativeElement;
      input.setAttribute('placeholder', 'Type home address')
    })
    // Listen to scroll events (both page & nested containers)

    window.addEventListener('scroll', this.scrollHandler, true);
    window.addEventListener('touchmove', this.scrollHandler, true);

  }
  ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollHandler, true);
    window.removeEventListener('touchmove', this.scrollHandler, true);
  }
  validateLocation(inputText: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.isPlaceSelected && (!inputText || inputText.trim().length < 3)) {
        resolve(false);
        return;
      }
      if (!this.isPlaceSelected && (!inputText || inputText.trim().length == 3)) {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ address: inputText }, (results: any, status: any) => {
          if (status === google.maps.GeocoderStatus.OK) {
            const valid = results.some((r: any) =>
              r.types.includes('locality') || r.types.includes('administrative_area_level_1') || r.types.includes('country')
            )
            resolve(valid);
          }
          else {
            resolve(false);
          }
        })
        return;
      }
      const service = new google.maps.places.AutocompleteService();
      service.getPlacePredictions({ input: inputText }, (predictions: any, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK && predictions && predictions.length > 0) {
          resolve(true);
          return;
        }
        else {
          const geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address: inputText }, (results: any, status: any) => {
            if (status === google.maps.GeocoderStatus.OK && results && results.length > 0) {
              resolve(true);
            }
            else {
              resolve(false);
            }
          })
        }
      })

    })
  }
  getAction(): any {
    const el = JSON.parse(localStorage.getItem('dentistInfo') || '{}') || {};
    const credentialingEvent = JSON.parse(localStorage.getItem('credentialingEvent') || '{}');
    const eventStatus = credentialingEvent?.eventStatus;

    if (!el?.reCredentialDate) {
      return false;
    }
    const recredDate: Date = this.parseYyyyMmDd("" + el.reCredentialDate);

    if (!recredDate) {
      return false;
    }
    const locations = JSON.parse(localStorage.getItem('whLocations') || '[]');
    const isNonPar =
      locations.length > 0 &&
      locations.every(
        (loc: any) =>
          loc?.providerNetwork?.toLowerCase() === 'not participating'
      );
    if (isNonPar) {
      return false;
    }
    const today = new Date();
    const dueDate = new Date(recredDate);
    const value = Number(this.sharedService.credentialing_graceperiod);
    const gracePeriod = !value || isNaN(value) ? 180 : value;

    dueDate.setDate(dueDate.getDate() - gracePeriod);

    if (today < dueDate) {
      return false;
    }

    return true;
  }
  parseYyyyMmDd(dateString: string): Date {
    const year = Number(dateString.substring(0, 4));
    const month = Number(dateString.substring(4, 6)) - 1;
    const day = Number(dateString.substring(6, 8));

    return new Date(year, month, day);
  }
}
